import { useMemo } from 'react';

import { useSelector } from 'react-redux';

import { selectChannelById } from 'store/programs/selectors';
import { MixedItem } from 'store/railsBuilder/reducer.types';
import { ReduxStore } from 'store/types';

import parseParentalRating from 'services/data-manager/parsing/utils/parseParentalRating';

const useMixedItemParentalRating = (item: MixedItem) => {
    const channel = useSelector((state: ReduxStore) =>
        selectChannelById(state, item.channelId),
    );

    return useMemo(
        () =>
            item.parentalRating
                ? item.parentalRating
                : parseParentalRating(undefined, channel),
        [channel, item],
    );
};

export default useMixedItemParentalRating;
